import { TextareaAutosize, styled } from '@mui/material';
// import { COLORS } from "../../../theme/color";

export const DeclineOrderCon = styled('div')``;

export const StyledTextArea = styled(TextareaAutosize)`
  width: 100%;
  padding: 20px 10px;
`;
